export default (key) => {
  const num = key[key.length - 1] * 1;
  switch (key) {
    case 'brand':
      return { name: 'brand1', key: 0 };
    default:
      return { name: `brand${num + 1}`, key: num };
  }
};
